import type {LinkTarget, LinkTargetKind} from "../../../domain/entities/link-targets/link-target";
import {AbstractTileComponent} from "./abstract-tile.component";
import {LinkTileExternalComponent} from "./link-tile-external.component";
import {LinkTileKnowledgeObjectComponent} from "./link-tile-knowledge-object.component";
import {LinkTileGimmickComponent} from "./link-tile-gimmick.component";

/**
 * `kind` → tile-component-class lookup for `dashboard-creator._mountTile()`.
 *
 * Deliberately a SEPARATE file/map from `link-target-serializer.ts`'s
 * `LINK_TARGET_KINDS`/discriminator config (a design decision made during planning),
 * even though both describe "one entry per `LinkTargetKind`": a single
 * shared registry would make `domain/entities/link-targets/` import FROM
 * `components/dashboard-creator/tiles/` — a domain→UI layering violation —
 * and risks an import cycle the moment a `link-targets/index.ts` barrel
 * appears (this project uses barrels elsewhere, e.g. `_dialogs/index.ts`):
 * the tile components import the `LinkTarget` subclasses, so the domain
 * module importing back would resolve in an order-dependent way, with
 * `TILE_COMPONENT_BY_KIND`'s values potentially `undefined`.
 *
 * `tile-registry.test.ts` asserts this map's keys match
 * `LINK_TARGET_KINDS` exactly, so the two can never silently drift apart.
 */
export const TILE_COMPONENT_BY_KIND: Record<LinkTargetKind, new () => AbstractTileComponent<LinkTarget | null>> = {
    external: LinkTileExternalComponent,
    'knowledge-object': LinkTileKnowledgeObjectComponent,
    gimmick: LinkTileGimmickComponent,
};
